import BlankLayout from '../components/layout/BlankLayout';
import ROUTES from '../constants/Routes';
import AuditSheetContainer from '../pages/audit_sheet/AuditSheetContainer';
import BatchContainer from '../pages/dashboard/batch_dashboard/BatchContainer';
import ChartActivityContainer from '../pages/dashboard/ChartActivityContainer';
import ChartContainer from '../pages/dashboard/ChartContainer';

import DashboardContainer from '../pages/dashboard/DashboardContainer';
import DepartmentDBContainer from '../pages/dashboard/department_dashboard/DepartmentDBContainer';
import HospitalDashboardContainer from '../pages/dashboard/hospital_dasboard/HospitalDashboardContainer';
import MyAccountsWrapper from '../pages/dashboard/my_accounts/MyAccountsWrapper';
import PhysicianDashboardcotainer from '../pages/dashboard/physician_dashboard/PhysicianDashboardcotainer';
import PracticeInfoWrapper from '../pages/dashboard/practice_info/PracticeInfoWrapper';
import HelpContainer from '../pages/help/HelpContainer';
import MyChartsContainer from '../pages/my_charts/MyChartsContainer';
import MyChartsContainerV2 from '../pages/my_charts/MyChartsContainerV2';
import Notifications from '../pages/notifications/Notifications';
import UploadContainer from '../pages/upload/UploadContainer';
import DocumentViewerPage from '../pages/document_viewer/DocumentViewerPage';

const AppRouter = [
  {
    route: ROUTES.DASHBOARD,
    element: <DashboardContainer />,
  },
  {
    route: ROUTES.UPLOAD,
    element: <UploadContainer />,
  },
  {
    route: ROUTES.HELP,
    element: <HelpContainer />,
  },
  {
    route: ROUTES.MY_CHARTS,
    element: <MyChartsContainer />,
  },
  {
    route: ROUTES.MY_CHARTS_V2,
    element: <MyChartsContainerV2 />,
  },
  {
    route: ROUTES.VIEW_BATCH_AUDIT_SHEET,
    element: <AuditSheetContainer view={true} batch />,
    layout: BlankLayout,
  },
  {
    route: ROUTES.VIEW_RENDERER_BATCH_AUDIT_SHEET,
    element: <AuditSheetContainer view={true} batch />,
    layout: BlankLayout
  },
  {
    route: ROUTES.VIEW_AUDIT_SHEET,
    element: <AuditSheetContainer view={true} />,
    layout: BlankLayout,
  },
  {
    route: ROUTES.VIEW_RENDERRER_SINGLE_AUDIT_SHEET,
    element: <AuditSheetContainer view={true} />,
    layout: BlankLayout,
  },
  {
    route: ROUTES.SINGLE_AUDIT_SHEET_TYPE,
    element: <AuditSheetContainer view={true} type/>,
    layout: BlankLayout,
  },
  {
    route: ROUTES.HOSPITAL_DASHBOARD,
    element: <HospitalDashboardContainer />,
  },
  {
    route: ROUTES.CHARTS,
    element: <ChartContainer />,
  },
  {
    route: ROUTES.CHART_ACTIVITY_BREAKDOWN,
    element: <ChartActivityContainer />,
  },
  {
    route: ROUTES.DEPARTMENT_DASHBOARD,
    element: <DepartmentDBContainer />,
  },
  {
    route: ROUTES.MY_ACCOUNT,
    element: <MyAccountsWrapper />,
  },
  {
    route: ROUTES.PHYSICIAN_DASHBOARD,
    element: <PhysicianDashboardcotainer />,
  },

  {
    route: ROUTES.BATCH_DASHBOARD,
    element: <BatchContainer />,
  },
  {
    route: ROUTES.HOSPITAL_DEPARTMENT_DASHBOARD,
    element: <DepartmentDBContainer />,
  },
  {
    route: ROUTES.HOSPITAL_PHYSICIAN_DASHBOARD,
    element: <PhysicianDashboardcotainer />,
  },
  {
    route: ROUTES.DEPARTMENT_PHYSICIAN_DASHBOARD,
    element: <PhysicianDashboardcotainer />,
  },
  {
    route: ROUTES.NOTIFICATIONS,
    element: <Notifications />,
  },
  {
    route: ROUTES.PRACTICE_INFO,
    element: <PracticeInfoWrapper />,
  },
  {
    route: ROUTES.DOCUMENT_VIEWER_CHART,
    element: <DocumentViewerPage />,
    layout: BlankLayout,
  },
  {
    route: ROUTES.DOCUMENT_VIEWER_BATCH,
    element: <DocumentViewerPage />,
    layout: BlankLayout,
  },
];

export default AppRouter;
